module.exports = global.config = {
  product: {
    app: {
      name: "Daily Workout Screens",
      version: "21.12.22",
    },
  },
};
